var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0684 5.70903L6.69341 9.08403C6.58372 9.19372 6.44028 9.24997 6.29685 9.24997C6.15341 9.24997 6.00997 9.19372 5.90028 9.08403L3.93153 7.11528C3.70935 6.89591 3.70935 6.54153 3.93153 6.32216C4.15091 6.09997 4.50528 6.09997 4.72466 6.32216L6.29685 7.89153L9.27528 4.91591C9.49466 4.69372 9.84903 4.69372 10.0684 4.91591C10.2906 5.13528 10.2906 5.48966 10.0684 5.70903ZM7 0.25C3.27344 0.25 0.25 3.27344 0.25 7C0.25 10.7266 3.27344 13.75 7 13.75C10.7266 13.75 13.75 10.7266 13.75 7C13.75 3.27344 10.7266 0.25 7 0.25Z",
    fill: "#25E79F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmV);
export default __webpack_public_path__ + "static/media/confirmV.81bfdc63c53047d890076186bf7d1d55.svg";
export { ForwardRef as ReactComponent };